export const testimonials = [
  {
    id: 1,
    text: '"Excelente atendimento, tem preços e qualidade excelentes, sempre com o melhor preço, a Soldageo é uma empresa muito responsável."',
    name: 'Freddy Anderson',
    role: 'Cliente verificado',
    avatar: 'https://images.unsplash.com/photo-1521119989659-a83eee488004?auto=format&fit=crop&w=48&h=48',
  },
  {
    id: 2,
    text: '"Já comprei com eles três vezes. Oferecem um serviço excelente, máquinas de alta qualidade e importados diretamente. Também vendem na Argentina. Recomendo."',
    name: 'Eli Costa',
    role: 'Comprador recorrente',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=48&h=48',
  },
  {
    id: 3,
    text: '"Produto chegou dentro do prazo, embalado perfeitamente. O suporte técnico da equipe SoldaGeo foi essencial para a instalação. Ótima experiência!"',
    name: 'Carlos Mendes',
    role: 'Contratante de obra',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=48&h=48',
  },
];
